<template>
<div>
  <div class="case-tabs">
    <div
      :class="['case-tab', current_tab == 'Sifarnik' ? 'active' : '',]"
      @click="changeView('sifarnik')"
    >
      {{ $t('sifrarnici_tab.t1') }}
    </div>
    <div
      :class="[
        'case-tab',
        current_tab == 'Tarife' ? 'active' : '',
      ]"
      @click="changeView('tarife')"
    >
    {{ $t('sifrarnici_tab.t2') }}
    </div>
    <div
      :class="[
        'case-tab',
        current_tab == 'Predlošci' ? 'active' : '',
      ]"
      @click="changeView('template-docx')"
    >
    {{ $t('sifrarnici_tab.t3') }}
    </div>
    <div
      :class="[
        'case-tab',
        current_tab == 'TroskovnikReportEdit' ? 'active' : '',
      ]"
      @click="changeView('troskovnik-report-edit')"
    >
    {{ $t('sifrarnici_tab.t4') }}
    </div>
    <!-- <div
      :class="['case-tab', current_tab == 'Fakture' ? 'active' : '',]"
      @click="changeView('fakture')"
    >
      Fakture
    </div> -->
  </div>
</div>

</template>

<script>

export default {
    props:['current_tab'],
  methods: {

    changeView(nastavak) {
        this.$router.push("/"+nastavak);

    }
  },
  mounted() {
  },
  destroyed(){
  }
};
</script>